import { gql } from "@apollo/client";

const UPDATE_PERIOD = gql`mutation UpdatePeriod (
  $uid: UUID!,
  $name: String!, 
  $startDate: Datetime!, 
  $endDate: Datetime!,
  $openUserStart: Datetime,
  $openUserEnd: Datetime,
  $openUserForce: Boolean,
  $openAdminStart: Datetime,
  $openAdminEnd: Datetime,
  $openAdminForce: Boolean) {
  updatePeriodByUid(
    input: {
      periodPatch: {
        endDate: $endDate,
        startDate: $startDate,
        name: $name,
        openUserEnd: $openUserEnd,
        openUserForce: $openUserForce,
        openUserStart: $openUserStart,
        openAdminEnd: $openAdminEnd,
        openAdminForce: $openAdminForce,
        openAdminStart: $openAdminStart},
        uid: $uid})
        { clientMutationId  }}`;

const CREATE_PERIOD = gql`mutation CreatePeriod(
  $name: String!, 
  $startDate: Datetime!, 
  $endDate: Datetime!,
  $openUserStart: Datetime,
  $openUserEnd: Datetime,
  $openAdminStart: Datetime,
  $openAdminEnd: Datetime){
  createPeriod(
    input: { period: { 
      name: $name, 
      startDate: $startDate, 
      endDate: $endDate,
      openUserStart: $openUserStart,
      openUserEnd: $openUserEnd,
      openAdminStart: $openAdminStart,
      openAdminEnd: $openAdminEnd } }
  ) {
    period {
      uid
      name
      startDate
      endDate
    }
  }
} `;

const LIST_PERIODS = gql`query GetPeriods($first: Int = 100, $offset: Int = 0, $filter: PeriodFilter){
  allPeriods(
    filter: $filter,
    first: $first,
    offset: $offset,
    orderBy: [START_DATE_ASC, END_DATE_ASC, NAME_ASC]) {
    nodes {
      uid
      name
      startDate,
      endDate,
      openUserStart,
      openUserEnd,
      openUserForce,
      openAdminStart,
      openAdminEnd,
      openAdminForce,
      organizationUid,
      periodGradesByPeriodUid {
        nodes {
          gradeByGradeUid {
            name
            uid
          }
        }
      }
    }
    totalCount
  }
} `;

const LIST_PERIODS_INFO_ADMIN = gql`mutation PeriodsInfoAdmin {
  getPeriodsAllInfo(input: {}) {
    periodInfos {
      uid
      name
      openUserStart
      startDate
      endDate
      openUser
      openAdminStart
      openAdminEnd
      openAdmin
    }
  }
}
`;

const DELETE_PERIOD = gql`mutation DeletePeriod($periodUid: UUID!) {
  deletePeriodByUid(input: { uid: $periodUid }){
    period{
      uid
      name
    }
  }
}
`;

const GET_PERIOD = gql`query GetPeriod($periodUid: UUID!){
  periodByUid(uid: $periodUid){
    name
    uid
  }
} `;

export {
  UPDATE_PERIOD,
  CREATE_PERIOD,
  LIST_PERIODS,
  LIST_PERIODS_INFO_ADMIN,
  DELETE_PERIOD,
  GET_PERIOD,
};
